import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'semantic-ui-react'
import { I18N_LANGUAGE_STORAGE_KEY, supportedLanguages } from './constants'

const resolveSupportedLanguage = lang => {
  if (!lang) return null
  if (supportedLanguages[lang]) return supportedLanguages[lang].value
  const base = String(lang).split('-')[0]
  if (supportedLanguages[base]) return supportedLanguages[base].value
  return null
}

const getInitialLanguage = i18nInstance =>
  resolveSupportedLanguage(localStorage.getItem(I18N_LANGUAGE_STORAGE_KEY)) ||
  resolveSupportedLanguage(i18nInstance?.resolvedLanguage || i18nInstance?.language) ||
  resolveSupportedLanguage(navigator.language) ||
  'en'

export default () => {
  const { i18n, t: translate } = useTranslation()
  const [selectedLanguage, setSelectedLanguage] = React.useState(() => getInitialLanguage(i18n))

  const languageOptions = React.useMemo(
    () =>
      Object.values(supportedLanguages).map(language => ({
        key: language.id,
        value: language.value,
        text: translate(language.text.toLowerCase()),
      })),
    [translate]
  )

  const handleSelectLanguage = value => {
    setSelectedLanguage(value)
    // Persist only on deliberate switcher interaction
    // Language detector caches are disabled
    localStorage.setItem(I18N_LANGUAGE_STORAGE_KEY, value)
    i18n?.changeLanguage(value)
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <Dropdown
        placeholder={translate('selectLanguage')}
        onChange={(e, { value }) => {
          e.preventDefault()
          handleSelectLanguage(value)
        }}
        value={selectedLanguage}
        search
        closeOnEscape
        options={languageOptions}
      />
    </div>
  )
}
